import fetch from 'auth/FetchInterceptor';
import { BASE_URL } from 'constants/ApiConstant';

const AdminService = {
  getUsersActivity(data) {
    return fetch({
      url: `${BASE_URL}/user-stats/get-users-activity${data}`,
      method: 'get',
    });
  },

  getNewUserStats(data) {
    return fetch({
      url: `${BASE_URL}/user-stats/new-users${data}`,
      method: 'get',
    });
  },

  getAverageTimeSession() {
    return fetch({
      url: `${BASE_URL}/user-stats/average-time`,
      method: 'get',
    });
  },

  sendInvitation(data) {
    return fetch({
      url: `${BASE_URL}/admin/user/incomplete-profile-email`,
      method: 'post',
      data,
    });
  },

  registerEmployer(data) {
    return fetch({
      url: `${BASE_URL}/admin/user/employer`,
      method: 'post',
      data,
    });
  },

  assignCustomPackage(data) {
    return fetch({
      url: `${BASE_URL}/admin/subscription/custom-package`,
      method: 'post',
      data,
    });
  },

  assignPostpaidPackage(data) {
    return fetch({
      url: `${BASE_URL}/admin/subscription/postpaid-package`,
      method: 'post',
      data,
    });
  },

  cancelSubscription(data) {
    const { subscriptionID } = data;
    return fetch({
      url: `${BASE_URL}/admin/subscription/cancel/${subscriptionID}`,
      method: 'put',
    });
  },

  getTotalCount(data) {
    const { userType } = data;
    return fetch({
      url: `${BASE_URL}/user-stats/total-count`,
      method: 'get',
      params: { userType },
    });
  },

  getJobStats() {
    return fetch({
      url: `${BASE_URL}/job-stats/success-rate`,
      method: 'get',
    });
  },

  getEmployerSubscription(data) {
    return fetch({
      url: `${BASE_URL}/user-stats/employer-subscription${data}`,
      method: 'get',
    });
  },

  getJobsDetails(data) {
    const { filters } = data;
    return fetch({
      url: `${BASE_URL}/job-stats/get-jobs-detail${filters}`,
      method: 'get',
    });
  },

  reactivateAccount(id) {
    return fetch({
      url: `${BASE_URL}/admin/user/reactivate-account/${id}`,
      method: 'put',
    });
  },

  getTestimonials(data) {
    return fetch({
      url: `${BASE_URL}/admin/testimonials${data}`,
      method: 'get',
    });
  },

  getTestimonialById(id) {
    return fetch({
      url: `${BASE_URL}/admin/testimonials/${id}`,
      method: 'get',
    });
  },

  createTestimonial(data) {
    return fetch({
      url: `${BASE_URL}/admin/testimonials`,
      method: 'post',
      data,
    });
  },

  updateTestimonial(id, data) {
    return fetch({
      url: `${BASE_URL}/admin/testimonials/${id}`,
      method: 'put',
      data,
    });
  },

  toggleTestimonialStatus(id, active) {
    return fetch({
      url: `${BASE_URL}/admin/testimonials/${id}/status`,
      method: 'patch',
      params: { active },
    });
  },

  deleteTestimonial(id) {
    return fetch({
      url: `${BASE_URL}/admin/testimonials/${id}`,
      method: 'delete',
    });
  },

  searchTestimonialCompanies(search) {
    return fetch({
      url: `${BASE_URL}/admin/testimonials/companies`,
      method: 'get',
      params: { search },
    });
  },

  getCompanies(data) {
    return fetch({
      url: `${BASE_URL}/admin/companies${data}`,
      method: 'get',
    });
  },

  updateViewerSeats(data) {
    return fetch({
      url: `${BASE_URL}/admin/companies/viewer-seats`,
      method: 'put',
      data,
    });
  },

  getInvoices(data) {
    return fetch({
      url: `${BASE_URL}/admin/invoices${data}`,
      method: 'get',
    });
  },

  getCampaignStats(data) {
    return fetch({
      url: `${BASE_URL}/campaign-stats${data}`,
      method: 'get',
    });
  },

  getCompanyInvoiceDetails(companyId) {
    return fetch({
      url: `${BASE_URL}/admin/invoices/company/${companyId}`,
      method: 'get',
    });
  },

  getCompanyInvoiceHistory(companyId, data) {
    return fetch({
      url: `${BASE_URL}/admin/invoices/company/${companyId}/history${data}`,
      method: 'get',
    });
  },

  downloadInvoice(invoiceId) {
    return fetch({
      url: `${BASE_URL}/admin/invoices/${invoiceId}/download`,
      method: 'get',
      responseType: 'blob',
    });
  },
  getUpcomingScheduledCalls(data) {
    return fetch({
      url: `${BASE_URL}/campaign-stats/upcoming-calls${data}`,
      method: 'get',
    });
  },

  getPaymentPlans(data) {
    return fetch({
      url: `${BASE_URL}/admin/payment-plans${data}`,
      method: 'get',
    });
  },

  getPaymentPlanCatalog() {
    return fetch({
      url: `${BASE_URL}/admin/payment-plans/catalog`,
      method: 'get',
    });
  },

  createPaymentPlan(data) {
    return fetch({
      url: `${BASE_URL}/admin/payment-plans`,
      method: 'post',
      data,
    });
  },

  updatePaymentPlan(id, data) {
    return fetch({
      url: `${BASE_URL}/admin/payment-plans/${id}`,
      method: 'put',
      data,
    });
  },

  updatePaymentPlanPurchasable(id, purchasable) {
    return fetch({
      url: `${BASE_URL}/admin/payment-plans/${id}/status`,
      method: 'patch',
      params: { purchasable },
    });
  },
};

export default AdminService;
